import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M27 8h-2V3a1 1 0 00-1-1H8a1 1 0 00-1 1v5H5a3 3 0 00-3 3v10a1 1 0 001 1h4v7a1 1 0 001 1h16a1 1 0 001-1v-7h4a1 1 0 001-1V11a3 3 0 00-3-3zm-4 14v6H9V16h14zm0-14H9V4h14zm3 5a1 1 0 111-1 1 1 0 01-1 1z"/><path d="M12.89 21h6.22a1 1 0 000-2h-6.22a1 1 0 000 2zM12.89 25h6.22a1 1 0 000-2h-6.22a1 1 0 000 2z"/>';
export var PrinterSVG = function PrinterSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PrinterSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PrinterSVG);